import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Daphne9 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;

  seletedArmletType: string = ReflexdArmletType.Constant;

  seletedFoot: string = DaphneFoot.Plastik;



  defHideObjects = [
    '_yy',
    'kolcak_plastik',
  ];

  defShowObjects =  [
    'xxx_daphne_sirt_demiri_aluminyum_yyy',
    'xxx_daphne_alt_yyy',
    'daphne_9_basliksiz_sirt_yyy',
    'xxx_daphne_kolcak_sag_yyy',
    'xxx_daphne_kolcak_sol_yyy',
    'daphne_ayak_metal_yyy',
    'xxx_daphne_kolcak_dugme_yyy',
    'xxx_daphne_donati_yyy',
    'genisliksiz',
    'kizaksiz',
    'donati',
    'xxx_daphne_kolcak_dugme_sol_yyy',
    'xxx_daphne_kolcak_dugme_sag_yyy',
  ];


  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('daphne9');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes,['order'],['asc']);
    this.availableAnimations =  this.product.animations as  AnimationDefinition[];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });

    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });

      //await this.changeFoot(Store.state.selection.footAndHand);

      //await this.changeArmletType(Store.state.selection.armletType);

      if (Store.state.selection.footAndHand === DaphneFoot.Metal) {
        await this.changeFoot(DaphneFoot.Metal);
      }
      if (Store.state.selection.footAndHand === DaphneFoot.Plastik) {
        await this.changeFoot(DaphneFoot.Plastik);

        if (Store.state.selection.armletType === ReflexdArmletType.Constant) {
          await this.changeArmletType(ReflexdArmletType.Constant);
        }

      }
    }  else {
      await  this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }


  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new Daphne9Selection();
    selection.parts = [];

    selection.footAndHand = DaphneFoot.Plastik;
    selection.armletType = ReflexdArmletType.Constant;

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    await this.changeFoot(DaphneFoot.Plastik);
    await this.changeArmletType(ReflexdArmletType.Constant);
  }


  async changeFoot(foot:DaphneFoot) {
    if (foot === DaphneFoot.Metal) {
      await this._configuratorService.hideObjects({ objects: ['daphne_ayak_plastik_yyy','daphne_kolcak_demir_genisliksiz_plastik_yyy','xxx_daphne_sirt_demiri_plastik_yyy','kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['daphne_ayak_metal_yyy','daphne_kolcak_demir_genisliksiz_aluminyum_yyy','xxx_daphne_sirt_demiri_aluminyum_yyy','xxx_daphne_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = DaphneFoot.Metal;
      this.seletedFoot = DaphneFoot.Metal;
      Store.state.selection.armletType = ReflexdArmletType.Adjustable;
      this.seletedArmletType = ReflexdArmletType.Adjustable;
      this.armletAnimations(true);
    }
    if (foot === DaphneFoot.Plastik) {
      await this._configuratorService.hideObjects({ objects: ['daphne_ayak_metal_yyy','daphne_kolcak_demir_genisliksiz_aluminyum_yyy','xxx_daphne_sirt_demiri_aluminyum_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['daphne_ayak_plastik_yyy','daphne_kolcak_demir_genisliksiz_plastik_yyy','xxx_daphne_sirt_demiri_plastik_yyy','xxx_daphne_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = DaphneFoot.Plastik;
      this.seletedFoot = DaphneFoot.Plastik;
      //Store.state.selection.armletType = ReflexdArmletType.Adjustable;
      this.seletedArmletType = ReflexdArmletType.Adjustable;
      this.armletAnimations(true);
      if (Store.state.selection.armletType === ReflexdArmletType.Constant) {
        await this.changeArmletType(ReflexdArmletType.Constant);
      }
    }
  }

  armletAnimations(isKizakli: boolean) {
    let animations = [];


    if  (!isKizakli) {
      this.product.animations.forEach((element) => {
        if (!(element.animationName === 'a1'))  {
          animations.push(element);
        }
      });
    }  else {
      animations = this.product.animations as any[];

    }

    this.availableAnimations = animations;
    this.availableAnimationsChanged();
  }

  async changeArmletType(arm:ReflexdArmletType) {
    if (arm === ReflexdArmletType.Constant) {
      await this._configuratorService.showObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['daphne_kolcak_demir_genisliksiz_plastik_yyy','daphne_ayak_metal_yyy','daphne_kolcak_demir_genisliksiz_aluminyum_yyy','xxx_daphne_sirt_demiri_aluminyum_yyy','xxx_daphne_kolcak'], operator: FilterOperators.Contains });
      this.armletAnimations(false);
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
    }
    if (arm === ReflexdArmletType.Adjustable) {
      await this._configuratorService.hideObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['daphne_kolcak_demir_genisliksiz_plastik_yyy','xxx_daphne_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
      this.armletAnimations(true);
    }
  }


  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const  getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}
export class Daphne9Selection {
  parts: PartSelection[];
  footAndHand:DaphneFoot;
  armletType: ReflexdArmletType;

}
export class PartSelection {
  id: string;
  palette: string;
  color: string;
  name:string;
}
enum DaphneFoot {
  Metal = 'metal',
  Plastik = 'plastik',

}

enum ReflexdArmletType {
  Constant = 'constant',
  Adjustable = 'adjustable',
}



// WEBPACK FOOTER //
// ./src/components/families/daphne/Daphne9.ts